import { Card, Divider, Flex, Skeleton, Text } from "components/common"
import { t } from "i18next"
import theme from "utils/themeVars"
import { formatFractionalSaleAmount } from "../utilis/fractionalSaleCalculations"
import styles from "./fractionalBlocksSummary.module.less"

export default function FractionalBlocksSummary({
  blockCount,
  blocksTotal,
  taxTotal,
  partnerFeeTotal,
  grandTotal,
  feeLoading,
  isFiler,
  processingFee,
}) {
  const summarySkeleton = <Skeleton active height={20} width={72} />

  const rows = [
    {
      label: `${t("Property blocks")} (x${+blockCount > 0 ? blockCount : 1})`,
      value: formatFractionalSaleAmount(blocksTotal),
    },
    {
      label: t("Advance tax ({{filerStatus}})", {
        filerStatus: isFiler ? t("Filer") : t("Non Filer"),
      }),
      value: feeLoading ? summarySkeleton : formatFractionalSaleAmount(taxTotal),
    },
    {
      label: t("Processing fees"),
      value: formatFractionalSaleAmount(processingFee),
    },
    {
      label: t("Partner fee"),
      value: feeLoading ? summarySkeleton : formatFractionalSaleAmount(partnerFeeTotal),
    },
  ]

  return (
    <Card
      Shadow={false}
      className={styles.blocksSummaryCard}
      variant="gray"
      style={{ marginTop: 12, borderRadius: 8 }}
      title={<Text type="secondary">{t("Sale summary")}</Text>}
      headStyle={{
        background: theme["gray100"],
      }}
      bodyStyle={{ padding: "12px 16px" }}
      styles={{ "--card-padding-block": "0px" }}
    >
      {rows.map(item => (
        <Flex key={item.label} justify="space-between" className={"mbe-4"}>
          <Text type="secondary">{item.label}</Text>
          {item.value}
        </Flex>
      ))}
      <Divider style={{ margin: "8px 0" }} />
      <Flex justify="space-between" className={"mbe-4"}>
        <Text type="secondary">{t("Grand total")}</Text>
        <span className={styles.grandTotalValue}>{formatFractionalSaleAmount(grandTotal)}</span>
      </Flex>
    </Card>
  )
}
